import React from 'react';
import ServicePage from './ServicePage';
import { IconDroplet, IconShieldCheck, IconFileText } from '../../components/Icons';

const DATA = {
  icon: <IconDroplet size={32} />, category: 'ambiental',
  title: 'Estudios de Aguas',
  subtitle: 'Caracterización y evaluación de la calidad del recurso hídrico superficial y subterráneo.',
  norm: 'Decreto 1076 de 2015 – Resolución 0631 de 2015',
  desc: 'Realizamos estudios hidrológicos e hidrogeológicos completos para la caracterización, uso y manejo sostenible del recurso hídrico en áreas de influencia de proyectos mineros y de infraestructura, conforme a la normativa ambiental vigente.',
  details: [
    'Caracterización fisicoquímica y microbiológica',
    'Aforos y medición de caudales superficiales',
    'Evaluación de impactos sobre el recurso hídrico',
    'Estudios de calidad de aguas subterráneas',
    'Diseño de sistemas de tratamiento de aguas residuales',
    'Monitoreo de redes de calidad hídrica',
  ],
  related: [
    { icon: <IconShieldCheck size={18} />, label: 'ICAS',                  path: '/servicios/icas' },
    { icon: <IconFileText size={18} />,    label: 'Licencias Ambientales', path: '/servicios/licencias' },
  ],
};

export default function EstudiosAguas() { return <ServicePage data={DATA} />; }
